/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-25 11:31:10
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\reciptDelivery\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询收发明细列表
export function getReciptDeliveryList(params) {
  return request({
    url: '/wms/stockInOutDetail/listProduct',
    method: 'get',
    params
  })
}


// 查询收发明细详情
export function getReciptDeliveryDetail(params) {
  return request({
    url: '/wms/inOutDetailCode/list',
    method: 'get',
    params
  })
}

